



































































































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ActionButton, Button, DropDownButton } from '@/models'

import SkeletonBox from './SkeletonBox.vue'

@Component({
  components: {
    SkeletonBox
  }
})
export default class MobileAppBar extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly backButton!: boolean

  @Prop({ type: String, default: 'arrow_back' })
  readonly backButtonIcon!: string

  @Prop({ type: Array, default: () => [] })
  readonly buttons!: (ActionButton | DropDownButton)[]

  @Prop({ type: Boolean, default: true })
  readonly showShadow!: boolean

  @Prop({ type: String, default: null })
  readonly title!: string | null

  get hasActions () {
    return this.buttons.length > 0
  }

  checkEndSlot () {
    return this.$slots.end !== undefined || this.hasActions
  }

  checkStartSlot () {
    return this.$slots.start !== undefined || this.backButton
  }

  buttonKey (button: Button): string {
    return `${button.text}_${button.icon}_${button.color}`
  }

  handleBackButton () {
    if (this.$listeners.goBack !== undefined) {
      this.$emit('goBack')
    } else {
      this.$router.back()
    }
  }

  isDropDown (button: ActionButton | DropDownButton): button is DropDownButton {
    return (button as DropDownButton).items !== undefined
  }
}
